import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PageLayout: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="App">
    <Header />
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px 60px' }}>
      <Link to="/" style={{ color: '#888', fontSize: 13, textDecoration: 'none' }}>홈</Link>
      <span style={{ color: '#ccc', margin: '0 8px' }}>&gt;</span>
      <span style={{ color: '#333', fontSize: 13 }}>{title}</span>
      <h1 style={{ fontSize: 28, fontWeight: 800, margin: '20px 0 30px', color: '#222' }}>{title}</h1>
      <div style={{ fontSize: 15, lineHeight: 2, color: '#444' }}>{children}</div>
    </div>
    <Footer />
  </div>
);

// ==================== 고객센터 ====================

export const HelpPage = () => (
  <PageLayout title="도움말">
    <h3>📦 월드쉽 이용 안내</h3>
    <p>월드쉽은 해외 상품을 대신 구매하여 국내로 배송해드리는 <b>해외 구매대행 전문 스토어</b>입니다.</p>
    <h3>🔍 상품 검색</h3>
    <p>상단 검색창에서 원하는 상품을 검색하세요. 카테고리별 인기 상품도 메인 페이지에서 확인할 수 있습니다.</p>
    <h3>🛒 주문하기</h3>
    <p>상품 페이지에서 옵션을 선택하고 "구매하기" 또는 "장바구니" 버튼을 클릭하세요.</p>
    <h3>📞 문의</h3>
    <p>이메일: <b>mahicanj@naver.com</b><br/>운영시간: 평일 09:00 ~ 18:00 (주말/공휴일 휴무)</p>
  </PageLayout>
);

export const FAQPage = () => (
  <PageLayout title="자주 묻는 질문 (FAQ)">
    {[
      { q: '배송기간은 얼마나 걸리나요?', a: '해외 직배송 기준 7~15일 소요됩니다. 통관 사정에 따라 지연될 수 있습니다.' },
      { q: '개인통관고유부호가 뭔가요?', a: '해외 배송 상품 수령 시 필요한 번호입니다. 관세청 홈페이지(p.customs.go.kr)에서 무료 발급 가능합니다.' },
      { q: '교환/반품이 가능한가요?', a: '상품 하자의 경우 수령 후 7일 이내 교환/반품 가능합니다. 단순 변심에 의한 교환/반품 시 왕복 배송비가 발생합니다.' },
      { q: '관세가 부과되나요?', a: '미화 $150 이상 구매 시 관부가세가 부과될 수 있습니다. 통관 시 수입 주체는 수령인이며, 동일 수령인 이름으로 같은 날 입항하는 물품은 합산됩니다.' },
      { q: '배송 추적이 가능한가요?', a: '인천 입항 후부터 국내 택배사 운송장 조회가 가능합니다. 해외 현지 배송 구간은 추적이 어렵습니다.' },
      { q: 'A/S가 가능한가요?', a: '해외 구매대행 상품 특성상 A/S는 불가합니다. 상품 불량 시 교환 또는 환불로 처리됩니다.' },
      { q: '한국어 설명서가 포함되어 있나요?', a: '해외 상품 특성상 한국어 설명서는 포함되지 않습니다.' },
    ].map((item, i) => (
      <div key={i} style={{ marginBottom: 24, padding: '16px 20px', background: '#f9f9f9', borderRadius: 8 }}>
        <p style={{ fontWeight: 700, color: '#e62e04', margin: '0 0 8px' }}>Q. {item.q}</p>
        <p style={{ margin: 0, color: '#555' }}>A. {item.a}</p>
      </div>
    ))}
  </PageLayout>
);

export const ShippingPage = () => (
  <PageLayout title="배송 안내">
    <h3>📦 배송 방법</h3>
    <p>모든 상품은 해외에서 직접 배송됩니다. CJ대한통운을 통해 국내 배송됩니다.</p>
    <h3>⏱ 배송 기간</h3>
    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
      <tbody>
        {[
          ['주문/결제', '1일'],
          ['상품 검수', '1~2일'],
          ['해외 배송', '3~7일'],
          ['통관 절차', '1~3일'],
          ['국내 배송', '1~2일'],
          ['총 소요기간', '약 7~15일'],
        ].map(([step, time], i) => (
          <tr key={i} style={{ background: i % 2 === 0 ? '#f5f5f5' : '#fff' }}>
            <td style={{ padding: '10px 16px', border: '1px solid #eee', fontWeight: 600 }}>{step}</td>
            <td style={{ padding: '10px 16px', border: '1px solid #eee' }}>{time}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <h3>📋 주의사항</h3>
    <ul>
      <li>통관 사정에 따라 배송이 지연될 수 있습니다.</li>
      <li>해외 현지에서는 배송 추적이 어려우며, <b>인천 입항 이후</b>부터 운송장 조회가 가능합니다.</li>
      <li>화물 택배 기준: 150cm(가로+세로+높이) 이상, 1M(한 변) 이상, 20kg 이상 시 추가금 발생 가능</li>
    </ul>
  </PageLayout>
);

export const ReturnPolicyPage = () => {
  const [form, setForm] = React.useState({ order_number: '', phone: '', request_type: '반품', reason: '', detail_reason: '' });
  const [msg, setMsg] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.order_number || !form.phone || !form.reason) { setMsg('모든 필수 항목을 입력해주세요.'); return; }
    setSubmitting(true);
    try {
      const res = await fetch('/api/storefront/return-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) { setMsg(data.message); setForm({ order_number: '', phone: '', request_type: '반품', reason: '', detail_reason: '' }); }
      else { setMsg(data.detail || '신청 실패'); }
    } catch { setMsg('서버 오류가 발생했습니다.'); }
    setSubmitting(false);
  };

  return (
    <PageLayout title="반품/교환 안내">
      <h3>교환/반품 정책</h3>
      <p>주문 취소/환불/교환 정책은 <b>해당 마켓의 정책</b>에 따라 진행됩니다.</p>
      <h3>교환/반품 가능한 경우</h3>
      <ul>
        <li>상품 하자가 있는 경우 (수령 후 7일 이내)</li>
        <li>주문한 상품과 다른 상품이 배송된 경우</li>
        <li>배송 중 파손된 경우 (사진 증빙 필요)</li>
      </ul>
      <h3>교환/반품이 어려운 경우</h3>
      <ul>
        <li>단순 변심에 의한 교환/반품 (왕복 배송비 부담)</li>
        <li>사용 흔적이 있는 경우</li>
        <li>수령 후 7일 초과</li>
      </ul>

      <h3>반품/교환 신청</h3>
      <form onSubmit={handleSubmit} style={{ maxWidth: 500, display: 'flex', flexDirection: 'column', gap: 12 }}>
        <input type="text" placeholder="주문번호 *" value={form.order_number} onChange={e => setForm({...form, order_number: e.target.value})} style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6 }} />
        <input type="text" placeholder="연락처 (주문 시 입력한 번호) *" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6 }} />
        <select value={form.request_type} onChange={e => setForm({...form, request_type: e.target.value})} style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6 }}>
          <option value="반품">반품 (환불)</option>
          <option value="교환">교환</option>
        </select>
        <select value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6 }}>
          <option value="">사유 선택 *</option>
          <option value="상품 불량/하자">상품 불량/하자</option>
          <option value="주문과 다른 상품 수령">주문과 다른 상품 수령</option>
          <option value="배송 중 파손">배송 중 파손</option>
          <option value="단순 변심">단순 변심 (왕복 배송비 부담)</option>
          <option value="기타">기타</option>
        </select>
        <textarea placeholder="상세 사유 (선택)" value={form.detail_reason} onChange={e => setForm({...form, detail_reason: e.target.value})} rows={3} style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6, resize: 'vertical' }} />
        <button type="submit" disabled={submitting} style={{ padding: '12px', background: '#FF6B35', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 'bold', cursor: 'pointer' }}>
          {submitting ? '접수 중...' : '반품/교환 신청'}
        </button>
        {msg && <p style={{ color: msg.includes('접수') ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>{msg}</p>}
      </form>
      <p style={{ marginTop: 16, color: '#888' }}>이메일 문의: <b>mahicanj@naver.com</b></p>
    </PageLayout>
  );
};

// ==================== 쇼핑 가이드 ====================

export const HowToOrderPage = () => (
  <PageLayout title="주문 방법">
    <h3>1️⃣ 상품 선택</h3>
    <p>메인 페이지 또는 검색을 통해 원하는 상품을 찾아 클릭하세요.</p>
    <h3>2️⃣ 옵션 선택</h3>
    <p>색상, 사이즈 등 원하는 옵션을 선택하고 수량을 지정하세요.</p>
    <h3>3️⃣ 장바구니 또는 바로 구매</h3>
    <p>"장바구니" 버튼으로 담아두거나, "구매하기" 버튼으로 바로 주문하세요.</p>
    <h3>4️⃣ 주문 정보 입력</h3>
    <p>배송지, 연락처, <b>개인통관고유부호</b>를 정확히 입력해주세요.</p>
    <h3>5️⃣ 결제</h3>
    <p>카드, 토스페이, 카카오페이 등 원하는 결제수단으로 결제하세요.</p>
    <h3>6️⃣ 배송 확인</h3>
    <p>주문 후 7~15일 내 상품이 배송됩니다. 인천 입항 후 운송장 번호가 제공됩니다.</p>
  </PageLayout>
);

export const PaymentPage = () => (
  <PageLayout title="결제 안내">
    <h3>💳 지원 결제수단</h3>
    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
      <tbody>
        {[
          ['신용/체크카드', 'VISA, MasterCard, 국내 전 카드사'],
          ['간편결제', '토스페이, 카카오페이, 네이버페이, 삼성페이'],
          ['계좌이체', '실시간 계좌이체'],
          ['가상계좌', '무통장입금 (입금 확인 후 주문 처리)'],
        ].map(([method, detail], i) => (
          <tr key={i} style={{ background: i % 2 === 0 ? '#f5f5f5' : '#fff' }}>
            <td style={{ padding: '10px 16px', border: '1px solid #eee', fontWeight: 600, width: '30%' }}>{method}</td>
            <td style={{ padding: '10px 16px', border: '1px solid #eee' }}>{detail}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <h3>⚠️ 주의사항</h3>
    <ul>
      <li>가상계좌는 입금 기한 내 미입금 시 자동 취소됩니다.</li>
      <li>해외 결제 시 카드사에 따라 해외 결제 수수료가 부과될 수 있습니다.</li>
    </ul>
  </PageLayout>
);

export const DeliveryPage = () => (
  <PageLayout title="배송 방법">
    <h3>🚚 해외 배송 진행 절차</h3>
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '16px 0 24px' }}>
      {['주문/결제', '상품 검수', '해외 배송', '통관 절차', '국내 배송', '상품 수령'].map((step, i) => (
        <React.Fragment key={i}>
          <span style={{ background: '#1e3a5f', color: '#fff', padding: '8px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600 }}>{step}</span>
          {i < 5 && <span style={{ color: '#ccc', alignSelf: 'center' }}>→</span>}
        </React.Fragment>
      ))}
    </div>
    <h3>📦 배송사</h3>
    <p>CJ대한통운을 통해 국내 배송됩니다. 세관 통관 이후부터 운송장 조회가 가능합니다.</p>
    <h3>🏝 제주/도서산간</h3>
    <p>제주도 및 도서산간 지역은 추가 배송비 3,000원이 발생할 수 있습니다.</p>
  </PageLayout>
);

export const BuyerProtectionPage = () => (
  <PageLayout title="구매자 보호">
    <h3>🛡 월드쉽 구매자 보호 정책</h3>
    <p>월드쉽에서 구매하시는 모든 상품은 아래 보호 정책이 적용됩니다.</p>
    <div style={{ background: '#f0f7ff', padding: 20, borderRadius: 8, marginBottom: 20 }}>
      <h4 style={{ color: '#1e3a5f', margin: '0 0 12px' }}>✅ 보호 항목</h4>
      <ul style={{ margin: 0 }}>
        <li><b>상품 미수령 보호</b> - 배송 완료 미확인 시 전액 환불</li>
        <li><b>상품 불일치 보호</b> - 주문과 다른 상품 수령 시 교환 또는 환불</li>
        <li><b>상품 파손 보호</b> - 배송 중 파손 시 교환 또는 환불 (사진 증빙)</li>
        <li><b>품절 보호</b> - 현지 품절 시 전액 환불 + 안내</li>
      </ul>
    </div>
    <p>문제 발생 시 <b>mahicanj@naver.com</b>으로 연락해주세요. 7일 이내 처리해드립니다.</p>
  </PageLayout>
);

// ==================== 월드쉽 소개 ====================

export const AboutPage = () => (
  <PageLayout title="회사 소개">
    <div style={{ textAlign: 'center', marginBottom: 30 }}>
      <h2 style={{ fontSize: 32, color: '#1e3a5f', margin: '0 0 8px' }}>🌏 WORLDSHIP</h2>
      <p style={{ fontSize: 18, color: '#666' }}>해외 구매대행 전문 스토어</p>
    </div>
    <p>월드쉽은 알리익스프레스, 해외 쇼핑몰의 다양한 상품을 엄선하여 한국 소비자에게 합리적인 가격으로 제공하는 해외 구매대행 전문 스토어입니다.</p>
    <h3>🎯 월드쉽의 장점</h3>
    <ul>
      <li><b>엄선된 상품</b> - 품질 검증된 상품만 선별하여 판매</li>
      <li><b>합리적 가격</b> - 해외 직구 대비 편리한 가격</li>
      <li><b>안전한 배송</b> - CJ대한통운 국내 배송, 7~15일 소요</li>
      <li><b>한국어 고객지원</b> - 주문부터 수령까지 한국어 지원</li>
      <li><b>다양한 결제수단</b> - 카드, 토스페이, 카카오페이, 네이버페이 지원</li>
    </ul>
  </PageLayout>
);

export const TermsPage = () => (
  <PageLayout title="이용약관">
    <h3>제1조 (목적)</h3>
    <p>이 약관은 월드쉽(이하 "회사")이 운영하는 인터넷 쇼핑몰에서 제공하는 서비스의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.</p>
    <h3>제2조 (정의)</h3>
    <p>"쇼핑몰"이란 회사가 상품을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 상품을 거래할 수 있도록 설정한 가상의 영업장을 말합니다.</p>
    <h3>제3조 (약관의 게시와 개정)</h3>
    <p>회사는 이 약관의 내용과 상호, 영업소 소재지 주소, 대표자의 성명, 사업자등록번호, 연락처 등을 이용자가 쉽게 알 수 있도록 사이트의 초기 서비스 화면에 게시합니다.</p>
    <h3>제4조 (서비스의 제공)</h3>
    <p>회사는 다음과 같은 업무를 수행합니다: 상품에 대한 정보 제공 및 구매계약의 체결, 구매계약이 체결된 상품의 배송, 기타 회사가 정하는 업무.</p>
    <h3>제5조 (서비스의 중단)</h3>
    <p>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
  </PageLayout>
);

export const PrivacyPage = () => (
  <PageLayout title="개인정보처리방침">
    <h3>1. 수집하는 개인정보 항목</h3>
    <p>회사는 주문 및 배송을 위해 다음 정보를 수집합니다: 이름, 연락처, 배송 주소, 이메일, 개인통관고유부호</p>
    <h3>2. 개인정보의 수집 및 이용 목적</h3>
    <ul>
      <li>상품 주문 및 배송</li>
      <li>통관 절차 진행</li>
      <li>고객 문의 응대</li>
      <li>주문/배송 안내 알림</li>
    </ul>
    <h3>3. 개인정보의 보유 및 이용기간</h3>
    <p>회원 탈퇴 시 즉시 파기합니다. 단, 관계법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.</p>
    <ul>
      <li>계약 또는 청약철회 기록: 5년</li>
      <li>대금결제 및 재화공급 기록: 5년</li>
      <li>소비자 불만 또는 분쟁 처리 기록: 3년</li>
    </ul>
    <h3>4. 개인정보의 제3자 제공</h3>
    <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 단, 배송업무 수행을 위해 택배사에 필요한 최소한의 정보를 제공합니다.</p>
    <h3>5. 문의</h3>
    <p>개인정보 관련 문의: <b>mahicanj@naver.com</b></p>
  </PageLayout>
);

export const ContactPage = () => (
  <PageLayout title="문의하기">
    <div style={{ background: '#f9f9f9', padding: 24, borderRadius: 8, marginBottom: 24 }}>
      <h3 style={{ margin: '0 0 16px' }}>📧 이메일 문의</h3>
      <p style={{ fontSize: 18, fontWeight: 700, color: '#e62e04' }}>mahicanj@naver.com</p>
      <p>주문번호와 함께 문의 내용을 보내주시면 빠르게 답변드립니다.</p>
    </div>
    <div style={{ background: '#f9f9f9', padding: 24, borderRadius: 8, marginBottom: 24 }}>
      <h3 style={{ margin: '0 0 16px' }}>⏰ 운영시간</h3>
      <p>평일: 09:00 ~ 18:00<br/>주말/공휴일: 휴무<br/>이메일 문의는 24시간 접수 가능하며, 영업일 기준 1~2일 내 답변드립니다.</p>
    </div>
    <div style={{ background: '#f0f7ff', padding: 24, borderRadius: 8 }}>
      <h3 style={{ margin: '0 0 16px' }}>📋 문의 시 포함해주세요</h3>
      <ul>
        <li>주문번호</li>
        <li>문의 유형 (배송/교환/반품/기타)</li>
        <li>상세 내용 및 사진 (필요 시)</li>
      </ul>
    </div>
  </PageLayout>
);
